import { Button } from '@/components'
import Text from '@/components/Text/Text'
import { CheckIcon, DotIcon, LoaderCircle } from 'lucide-react'
import { useViewModel } from './viewModel'
import DynamicProgramRewardsListCard from '@/components/ProgramRewards/dynamic-program-rewards-list-card'
import { ReactNode } from 'react'

export default function ReviewProgram() {
  const {
    selectedDeviceNames,
    reviewedTOS,
    selectedUtility,
    utilityAccountNumber,
    onEnroll,
    eligible,
    isSubmitting,
    enrollmentSurveyContent,
    rewardsByCategory,
    selectedDeviceCounts,
    rewardDeviceLimits,
  } = useViewModel()
  return (
    <div className="flex flex-col justify-between h-full gap-5">
      <div className="flex flex-col gap-4">
        <section>
          <Text variant="h3">Review Program</Text>
          <Text variant="body2">
            Please review all your information before you enroll in this
            program.
          </Text>
        </section>
        <section>
          <DynamicProgramRewardsListCard
            rewardsByCategory={rewardsByCategory}
            selectedDeviceCounts={selectedDeviceCounts}
            rewardDeviceLimits={rewardDeviceLimits}
          />
          <div className="flex flex-col [&>*]:py-6 [&>*:not(:last-child)]:border-b [&>*]:border-solid [&>*]:border-themed-grey-200">
            {selectedUtility && (
              <Requirement
                title={'Utility provider'}
                content={<Text variant="body2">{selectedUtility.name}</Text>}
              />
            )}
            {selectedDeviceNames.length > 0 && (
              <Requirement
                title="Connected devices"
                content={
                  <div className="flex flex-col items-center">
                    {selectedDeviceNames.map((name, i) => (
                      <div className="inline-flex items-center" key={i}>
                        <DotIcon className="text-themed-grey-500" />
                        <Text variant="body2">{name}</Text>
                      </div>
                    ))}
                  </div>
                }
              />
            )}
            {utilityAccountNumber && (
              <Requirement
                title="Utility account number"
                content={<Text variant="body2">{utilityAccountNumber}</Text>}
              />
            )}
            {reviewedTOS && (
              <Requirement
                title="Terms and Conditions"
                content={<Text variant="body2">Accepted</Text>}
              />
            )}
            {enrollmentSurveyContent.map((survey) => (
              <Requirement
                title={survey.header}
                content={
                  <>
                    {survey.rowItems.map((row, i) => (
                      <Text key={`survey-${i}`} variant="body2">
                        {row}
                      </Text>
                    ))}
                  </>
                }
              />
            ))}
          </div>
        </section>
      </div>
      <Button
        id="program-apply-now"
        onClick={onEnroll}
        disabled={!eligible || isSubmitting}
      >
        Apply Now
        {isSubmitting && (
          <LoaderCircle size={16} className="animate-spin block" />
        )}
      </Button>
    </div>
  )
}

function Requirement({
  title,
  content,
}: {
  title: string
  content: ReactNode
}) {
  return (
    <section className="flex flex-row w-full gap-2">
      <div className="bg-base-green-100 p-1 size-8 flex items-center justify-center rounded-lg">
        <CheckIcon className="text-green-500 size-5" />
      </div>
      <div>
        <div className="flex items-center justify-between w-full">
          <Text variant="body1">{title}</Text>
        </div>
        {content}
      </div>
    </section>
  )
}
